export const simulatePrice = ({ principal, monthlyRate, months }) => {
  const installment =
    (principal * monthlyRate * (1 + monthlyRate) ** months) /
    ((1 + monthlyRate) ** months - 1)
  const rows = []
  let balance = principal
  for (let i = 1; i <= months; i++) {
    const interest = balance * monthlyRate
    const amortization = installment - interest
    balance -= amortization
    rows.push({ month: i, installment, interest, amortization, balance: Math.max(0, balance) })
  }
  return rows
}

export const simulateSac = ({ principal, monthlyRate, months }) => {
  const amortization = principal / months
  const rows = []
  let balance = principal
  for (let i = 1; i <= months; i++) {
    const interest = balance * monthlyRate
    const installment = amortization + interest
    balance -= amortization
    rows.push({ month: i, installment, interest, amortization, balance: Math.max(0, balance) })
  }
  return rows
}

export const totalsOf = (rows) => ({
  totalPaid: rows.reduce((acc, r) => acc + r.installment, 0),
  totalInterest: rows.reduce((acc, r) => acc + r.interest, 0),
})
